import './DataTableSelectionChip.css';
export var selectionChip = '_1rlvxpp4-3-15-1';
export var selectionChipWrapper = {condensed:'_1rlvxpp1-3-15-1 _1rlvxpp0-3-15-1','default':'_1rlvxpp2-3-15-1 _1rlvxpp0-3-15-1',comfortable:'_1rlvxpp3-3-15-1 _1rlvxpp0-3-15-1'};